import { Ok, takeLeading } from "starfx";

import { isOk } from "../helpers";
import { schema } from "../schema";
import { xDbc, xouterApi, xThunk } from "../xapis";

import type { Next, ApiCtx } from "starfx";
import type { IGroupMember } from "@app/types";
export const loadUiState = xouterApi.get(
  "/persist",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    yield* next();
    if (isOk(ctx.json)) {
      console.log("loadUiState", ctx.json.value);
    }
  }
);

//IMPORTANT (!)//
export const debounceThx = xDbc.create(
  "/debounceThx",
  { supervisor: takeLeading },
  function* (ctx, next) {
    if (ctx.key === "out") {
      ctx.result = Ok(false);
      yield* next();
      return;
    }
    ctx.result = Ok(true);
    yield* next();
  }
);

export const prepareHydration = xouterApi.get<IGroupMember[]>(
  "/pidb",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    if (!ctx.payload || !ctx.payload.length) {
      return;
    }
    // at the moment we have only one group.
    // if we will have users with multiple groups, we will need to refactor this
    // in a for loop

    const who = ctx.payload?.[0] || ({} as IGroupMember);
    //NOTE THAT WE ARE FORCING HERE,
    // the J stands for JurnalGold -- when the app is for business and runs in CEF
    // the K stands for Personal Karma -- when the app is for personal use and runs also in CEF
    // we don't have a case for the web version, but we can add it later, for now, we are forcing the J
    // todo: https://github.com/VldMrgnn/jgap/issues/20 create a utility function to determine the app type and add a browser version

    const indexDbName = `w.J${who.ME_AMAXAVO}.${who.PERSEED}`; //w.J16.SWCRE//
    console.log("indexDbName", indexDbName);
    ctx.request = ctx.req({
      method: "GET",
      url: `/pidb?db=${indexDbName}`,
    });
    yield* next();
    if (isOk(ctx.json)) {
      console.log("prepareHydration", ctx.json.value);
    }
  }
);

export const setLoaderPopup = xThunk.create<boolean>(
  "/setLoaderPopup",
  function* (ctx, next) {
    yield* schema.update(schema.loaderPopup.set(ctx.payload));
    yield* next();
  }
);
